import moment from 'moment'
import path from 'path'
import * as Constants from '../../services/Constants'
import { logger } from '../../services/Logger'
import { checkDirectoryWithFallback } from '../../utils'

const log = logger.createChildLogger({ name: 'ScreenRecording' })

/**
 * throws { code: 'directory_error' }
 */
export async function generateOutputFilename(screenRecordSaveDirectory: string) {
    const fallbackDirectories = [Constants.defaultDirectories.screen_recording, Constants.defaultDirectories.documents]

    log.verbose('generateOutputFilename', ``, { screenRecordSaveDirectory, fallbackDirectories })

    const checkDirectoryResult = await checkDirectoryWithFallback(screenRecordSaveDirectory, fallbackDirectories)

    log.verbose(
        'generateOutputFilename',
        `checkDirectoryChooseDefaultThrows("${screenRecordSaveDirectory}") returned:`,
        {
            checkDirectoryResult,
        }
    )

    if (checkDirectoryResult.directory) {
        const filenameBase = `muse-screen-recording_${moment().format('YYYY-MM-DD_HHmmssSS')}`
        const filename = filenameBase + `.webm`

        return {
            directory: checkDirectoryResult.directory,
            filenameBase: filenameBase,
            filename: filename,
            fullPath: path.join(checkDirectoryResult.directory, filename),
            isFallbackDirectory: checkDirectoryResult.isFallbackDirectory,
        }
    } else {
        log.error('generateOutputFilename', `throwing directory_error for dir="${screenRecordSaveDirectory}".`)

        throw { code: 'directory_error', path: screenRecordSaveDirectory }
    }
}
